module.exports = __webpack_public_path__ + "img/line-chart-view.98e92e9a.svg";